function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25 29a10.5 8 0 11-21 0 10.5 8 0 1121 0z",
  transform: "matrix(1.23226 0 0 1.31579 -2.594 -12.526)",
  strokeWidth: 0.785
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 28.5a1 .5 0 11-2 0 1 .5 0 112 0z",
  transform: "matrix(1.23226 0 0 1.31579 -2.1 -11.342)",
  strokeWidth: 0.785
}), /*#__PURE__*/React.createElement("path", {
  d: "M13 26a2 2 0 11-4 0 2 2 0 114 0zM20 26a2 2 0 11-4 0 2 2 0 114 0z",
  transform: "matrix(1.23226 0 0 1.31579 -2.594 -12.526)",
  strokeWidth: 0.785
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.961 19.053v5.263M19.587 19.053v5.263"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.194 29.579c2.251.25 2.556-1.234 2.957-2.632.753 1.535.74 2.632 3.08 2.632",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.568 20.895v-9.737l6.161 5.263M26.98 20.895v-9.737l-6.16 5.263"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.335 25.632l8.626 1.315h0M3.568 29.579h6.161M28.213 25.632l-8.626 1.315h0M26.98 29.579h-6.16M27.053 16.406a24.458 24.458 0 017.937-1.3c11.23 0 20.333 7.363 20.333 16.447C55.323 40.636 46.22 48 34.99 48c-9.2 0-20.332-3.947-17.929-7.947 1.939-2.053 3.701-.797 8.687.053C31 41 41.768 41.42 46.697 34.843h0",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 23c-3.954 4.848-1.93 8.324 0 10.526-4.929 0-13.555-1.316-13.555 6.58",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.961 35.632C3.568 39.184 2.335 48 17.123 41.42M6.032 33.526c-12.322 9.21 0 7.895 0 7.895"
}));

var SvgCat = function SvgCat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cat.6b092948.svg";
export { ForwardRef as ReactComponent };